var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import draggable from 'vuedraggable';
import QiniuUpload from '@/common/components/QiniuUpload.vue';
import { QINIU_DOMAIN, IMAGE_SIZE, formatImageUrl } from '@/common/utils/qiniu-constant';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
var FormFileUpload = /** @class */ (function (_super) {
    __extends(FormFileUpload, _super);
    function FormFileUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.uploadParams = {
            listType: 'text',
            accept: '',
            showFileList: false,
            limit: 1,
            size: 10,
            multiple: false,
            isFile: false,
            uploadFileList: [],
            bucket: 'image',
            domain: QINIU_DOMAIN.image + "/",
            wm: IMAGE_SIZE.small,
            exceed_message: "\u6700\u591A\u53EF\u4E0A\u4F201\u4E2A\u6587\u4EF6",
        };
        _this.files = [];
        _this.curImageIndex = 0;
        _this.dragging = false; // 拖拽组件参数,拖拽中
        return _this;
    }
    Object.defineProperty(FormFileUpload.prototype, "dragOptions", {
        // 拖拽组件配置
        get: function () {
            return {
                animation: 200,
                // group: 'fileList', // 如果group是固定值，那么一个页面上多个组件可以相互拖拽
                disabled: !this.isDragging,
                ghostClass: 'ghost',
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormFileUpload.prototype, "previewImg", {
        get: function () {
            if (this.type === 'image' && this.files.length > 0) {
                return this.files.map(function (file) { return formatImageUrl(file.url, 'large'); });
            }
            return [];
        },
        enumerable: false,
        configurable: true
    });
    FormFileUpload.prototype.created = function () {
        var params = {
            listType: 'text',
            accept: this.accept,
            showFileList: false,
            limit: this.limit,
            size: this.size,
            multiple: this.limit && this.limit > 1,
            isFile: false,
            uploadFileList: [],
            bucket: 'image',
            domain: QINIU_DOMAIN.image + "/",
            wm: IMAGE_SIZE.small,
            exceed_message: "\u6700\u591A\u53EF\u4E0A\u4F20" + this.limit + "\u4E2A\u6587\u4EF6",
        };
        if (this.type === 'file') {
            params.bucket = 'file';
            params.domain = QINIU_DOMAIN.file + "/";
            params.wm = '';
            params.isFile = true;
        }
        if (this.uploadFiles && this.uploadFiles.length > 0) {
            this.files = this.uploadFiles;
            params.uploadFileList = this.uploadFiles;
        }
        if (this.customParams) {
            params = Object.assign(params, this.customParams);
        }
        this.uploadParams = __assign(__assign({}, this.uploadParams), params);
    };
    FormFileUpload.prototype.filesChange = function (newVal) {
        if (newVal && newVal.length > 0) {
            this.files = newVal;
            this.uploadParams.uploadFileList = newVal;
        }
        else {
            this.uploadParams.uploadFileList = [];
            this.files = [];
        }
    };
    FormFileUpload.prototype.getFiles = function (file) {
        if (file) {
            this.files = file;
        }
        else {
            this.files = [];
        }
        this.$emit('change', this.files);
    };
    FormFileUpload.prototype.deleteImg = function (file) {
        this.$refs.upload.imgRemove(file);
    };
    FormFileUpload.prototype.getImgUrl = function (url) {
        return formatImageUrl(url, 'small');
    };
    FormFileUpload.prototype.showLargerImg = function (e) {
        this.curImageIndex = e;
        this.$refs.imagesView.showViewer = true;
    };
    FormFileUpload.prototype.getFileLimitName = function (filename) {
        if (filename && filename.length > 3) {
            var index = filename.lastIndexOf('.');
            var type = filename.substring(index);
            var name = filename.substring(0, index);
            var length = name.length;
            var result = name;
            if (name.length > 20) {
                result = name.substring(0, 15) + "..." + name.substring(length - 2);
            }
            return "" + result + type;
        }
        return '';
    };
    FormFileUpload.prototype.focus = function () {
        this.$refs.target.focus();
    };
    FormFileUpload.prototype.dragChange = function () {
        this.$emit('change', this.files);
    };
    __decorate([
        Prop({ type: String, default: '' })
    ], FormFileUpload.prototype, "label", void 0);
    __decorate([
        Prop({ type: String, default: '' })
    ], FormFileUpload.prototype, "prop", void 0);
    __decorate([
        Prop({ type: Boolean, default: true })
    ], FormFileUpload.prototype, "hasError", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], FormFileUpload.prototype, "disabled", void 0);
    __decorate([
        Prop({ type: String, default: 'image' })
    ], FormFileUpload.prototype, "type", void 0);
    __decorate([
        Prop({ type: Number, default: 1 })
    ], FormFileUpload.prototype, "limit", void 0);
    __decorate([
        Prop({ type: Number, default: 10 })
    ], FormFileUpload.prototype, "size", void 0);
    __decorate([
        Prop({ type: String, default: '.jpg,.jpeg,.png' })
    ], FormFileUpload.prototype, "accept", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], FormFileUpload.prototype, "uploadFiles", void 0);
    __decorate([
        Prop({ type: Object })
    ], FormFileUpload.prototype, "customParams", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], FormFileUpload.prototype, "isDragging", void 0);
    __decorate([
        Watch('uploadFiles', {
            deep: true,
            immediate: false,
        })
    ], FormFileUpload.prototype, "filesChange", null);
    FormFileUpload = __decorate([
        Component({
            components: {
                QiniuUpload: QiniuUpload,
                Draggable: draggable,
            },
        })
    ], FormFileUpload);
    return FormFileUpload;
}(Vue));
export default FormFileUpload;
